{
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "properties": {},
      "geometry": {
        "coordinates": [
          [
            [
              93.07521086152968,
              4.847497315841466
            ],
            [
              101.4558292349306,
              -5.730313839356356
            ],
            [
              116.96350779666284,
              -11.827051705492465
            ],
            [
              124.22357412444956,
              -11.303689113667517
            ],
            [
              141.02846150353025,
              -9.32489629821832
            ],
            [
              141.15667324689758,
              -2.6645105530845115
            ],
            [
              128.32122954732893,
              3.6174349076974437
            ],
            [
              117.87077336405389,
              4.1385506626944135
            ],
            [
              115.70627987137948,
              4.338725090800352
            ],
            [
              114.35803531655938,
              1.2243781542084093
            ],
            [
              110.71275592201766,
              1.0297407377764785
            ],
            [
              109.68850444189837,
              2.115687935597265
            ],
            [
              105.15422354882037,
              0.24686254762553972
            ],
            [
              102.61068852537028,
              1.1510942561412065
            ],
            [
              98.29437944501518,
              4.652534735765258
            ],
            [
              95.28970982959675,
              6.40602665332959
            ],
            [
              93.07521086152968,
              4.847497315841466
            ]
          ]
        ],
        "type": "Polygon"
      }
    }
  ]
}